import { SortComponent } from '@ltvco/refresh-lib';

export const Sort = SortComponent;
